import { render, staticRenderFns } from "./Atencion.vue?vue&type=template&id=438485ea&scoped=true"
import script from "./Atencion.vue?vue&type=script&lang=ts"
export * from "./Atencion.vue?vue&type=script&lang=ts"
import style0 from "./Atencion.vue?vue&type=style&index=0&id=438485ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438485ea",
  null
  
)

export default component.exports